<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Utiliser les outils numériques et l’informatique" index-progression-courante="3"
                   index-progression-secondaire="4"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="gererinformations"/>
    <footer-applis ecran-precedent="mobiliserraisonnements" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'utiliseroutilsnumeriques',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie et accède aux fonctions de base des outils informatiques ou numériques'
      }, {
        niveau: 2,
        valeur: 'J\'utilise partiellement les fonctionnalités de base d’un ordinateur (traitement de texte, messagerie, internet)'
      }, {
        niveau: 3,
        valeur: 'J\'utilise les outils informatiques et numériques liés à sa situation'
      }, {
        niveau: 4,
        valeur: 'Je personnalise les ressources informatiques et numériques au service de ma situation et de mon parcours'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.utiliseroutilsnumeriques = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('gererinformations');
    }
  }
}
</script>